// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editable-row-operations a[data-v-d981e328] {\n  margin-right: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
